import './index.css';
import { createGlobalStyle } from "styled-components";

const GlobalStyles = createGlobalStyle`
* {
  margin: 0;
  font-family: 'Yati';
}

body {
  background-color: ${props => props.theme.backgroundColor};   
}

.ant-table-thead {
  border-radius: 8px;
  
  th {
    border: none !important;
    background: ${props => props.theme.backgroundColor} !important;

    ::before {
      display: none;
    }

    :first-child {
      border-bottom-left-radius: 8px;
    }

    :last-child {
      border-bottom-right-radius: 8px;
    }
  }
}

.ant-select {
  height: 48px;
  border-radius: 8px;

  .ant-select-selector {
    border-radius: 8px;
    padding: 8px 16px !important;
  }
}

.ant-input {
  padding: 8px 16px;
  height: 48px;
}

.ant-input:not(.ant-input-status-error) {
  border: 1px solid #CCC;
  border-radius: 8px;


  :focus {
    box-shadow: none !important;
  }
}

.ant-input-affix-wrapper:not(.ant-input-affix-wrapper-status-error) {
  border: 1px solid #CCC;
  border-radius: 8px;
  padding: 0 16px;

  :hover {
    border: 1px solid #CCC;
  }

  :focus {
    box-shadow: none !important;
  }

  textarea {
    padding-left: 0;
    padding-right: 0;
  }
}

.ant-menu-item-selected {
  background: ${props => props.theme.primaryColor} !important;
  color: #fff !important;

  :hover {
    background: ${props => props.theme.primaryColor} !important;
  }
}

.ant-menu-item:not(.ant-menu-item-selected) {
  background: #fff !important;
  color: #1D1014;

  svg path, svg circle, svg rect {
    stroke: ${props => props.theme.primaryColor} !important;
  }

  :hover {
    background: #fff !important;
  }
}

.ant-spin-dot i {
  background-color: ${props => props.theme.primaryColor} !important;
}

.ant-btn-icon {
  display: flex;
}

.ant-btn-primary {
border-radius: 8px;
background-color: ${props => props.theme.primaryColor};
box-shadow: rgb(0 0 0 / 20%) 0px 3px 1px -2px, rgb(0 0 0 / 14%) 0px 2px 2px 0px, rgb(0 0 0 / 12%) 0px 1px 5px 0px;
font-size: 16px;
font-weight: 600;

  :hover {
      background-color: ${props => props.theme.primaryRgb('86%')} !important;
  }
}

.ant-btn-default {
border-radius: 8px;
border-color: #B9B9B9 !important;
color: #1D1014 !important;
font-size: 16px;
font-weight: 600;

  :hover {
    border-color: #B9B9B9 !important;
    color: #1D1014 !important;
  }
}


.ant-switch {
min-width: auto;
height: 24px;
}

.ant-switch-handle {
  top: 3px !important;
}

.ant-switch-inner {
  width: 40px;
  height: 24px;
  background: #F00;
}

.ant-switch-checked .ant-switch-inner {
  background: #009800 !important;
}


/* width */
.custom-scroll::-webkit-scrollbar {
width: 3px;
}

/* Track */
.custom-scroll::-webkit-scrollbar-track {
background: #f1f1f1; 
}

/* Handle */
.custom-scroll::-webkit-scrollbar-thumb {
background: #888; 
}

/* Handle on hover */
.custom-scroll::-webkit-scrollbar-thumb:hover {
background: #555; 
}

`;

export default GlobalStyles;